import gql from 'graphql-tag'

export const GET_USERS_PAGINATION_QUERY = gql`
  query GetUsersPagination (
    $orderBy: [OrderByInput!],
    $skip: Int!,
    $take: Int!,
    $isActive: Boolean!
    $userGroupAlt: String
    $query: String
  ) {
    getUsers(
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        isActive: $isActive
        userGroupAlt: $userGroupAlt
        query: $query
      }
    ){
      hasMore
      total
      items {
        id
        isActive
        email
        telNumber
        firstName
        lastName
        patronymic
        fullName
        shortFullName
        userGroupAlt
        profilePhotoX64 {
            id
            photoSize
            fullUri
        }
      }
    }
  }
`
